import React from 'react';
import classNames from 'classnames';
import cls from './CardList.module.css';

interface CardListProps {
    classes?: string;
    children?: React.ReactNode;
}

export const CardList = ({ classes, children }: CardListProps) => {
    return <div className={classNames(cls.CardList, [classes])}>{children}</div>;
};
